import { BinScatterMultiSelectResult } from 'libs/end-to-end/src/bin-scatter';

export const getLevelKeysFromBinScatterMultiSelectResult = ({
  result,
}: {
  result: BinScatterMultiSelectResult | null;
}) => {
  return Object.entries(result?.results ?? {}).map(([key]) => key);
};
